import * as Yup from 'yup';

export const validationSchema = Yup.object({
	reportedVatAmount: Yup.number()
		.required('Reported VAT Amount is required')
		.min(0, 'Reported VAT Amount must be greater than or equal to 0'),
	comment: Yup.string().max(1000, 'Comment must be less than 1000 characters'),
});
